import jwtDecode from 'jwt-decode'
import { useEffect, useRef, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useSelector } from 'statux'

import Form from '../../../components/Form/Form'
import InputPassword from '../../../components/InputPassword/InputPassword'
import RichText from '../../../components/RichText/RichText'

import { fetchClient } from '../../../utils/fetch'
import { getQueryParams } from '../../../utils/location'

import authProvider from '../../../utils/auth-provider'

export default function SetPassword (props = {
    heading: null,
    richText: null,
    submitBtnText: null,
    redirect: null,
    redirectFailure: null,
    successMessage: null
}) {
    const history = useHistory()

    const user = useSelector('user')

    const {
        refresh,
        ticket,
        token,
        ...rest
    } = getQueryParams()

    const submitMsg = useRef()

    const [submissionState, setSubmissionState] = useState({
        success: null,
        message: null
    })

    const isDisabled = () => submissionState.success !== null

    const id = 'reset-password'

    const passwordMinLength = 8

    const redirect = (success = true) => {
        let url = props[success ? 'redirectSuccess' : 'redirectFailure'] || '/'

        if (success
                && rest['advanced-membership-checkout'])
            url += `${url.match(/\?/)
                ? '&'
                : '?'}advanced-membership-checkout=${
                    rest['advanced-membership-checkout']}`

        history.replace(url,
            null,
            null)
    }

    const onSubmit = async (e) => {
        let endpoint = '/auth/change-password'

        let headers = {}

        let session = null

        const inputPassword = e.target.querySelector(`#${id}-password`)

        const json = {
            new_password: inputPassword.value
        }

        if (ticket) {
            endpoint += '/change'

            json.ticket = ticket
        }

        if (token) {
            json.old_password = 'xxxxxxxx'

            session = jwtDecode(token) || {}

            headers = session['https://hasura.io/jwt/claims'] || {}

            headers.authorization = `Bearer ${token}`
        }

        const res = await fetchClient
            .post(endpoint, { json, headers })
            .catch((err) => err)

        const isError = Boolean((res.message || '').length)

        setSubmissionState({
            success: !isError,
            message: res.message
                || props.successMessage
                || 'Successfully updated password.'
        })
    }

    useEffect(() => {
        if (!ticket
                && !token)
            return redirect(false)

        if (!token)
            return

        authProvider.setSession({
            jwt_token: token,
            refresh_token: refresh,
            user: JSON.parse(JSON.stringify(user))
        })

        authProvider.setRefreshSession()

        if (authProvider.bc)
            authProvider.bc.postMessage({
                id: authProvider.id,
                token
            })
    }, [])

    useEffect(() => {
        if (submissionState.message
                && submitMsg.current)
            submitMsg.current.focus()

        if (!submissionState.success)
            return

        redirect(Boolean(token || user))
    }, [submissionState.message])

    if (!ticket
            && !token)
        return null

    return (
        <div className="reset-password">
            <h1
                className="heading-2 margin-b"
            >
                {props.heading || 'Reset password.'}
            </h1>
            <RichText
                html={props.richText}
            />
            <Form
                id={id}
                className="reset-password-form margin-3-t"
                onSubmit={onSubmit}
                disabled={isDisabled()}
                aria-describedby={submissionState.message
                    && `${id}-submit-msg`}
            >
                {user
                    && (
                        <input
                            className="display-none"
                            type="email"
                            name="username"
                            autoComplete="username"
                            value={user.email}
                            readOnly
                        />
                    )}
                <div className="form-field-floating margin-3-b">
                    <InputPassword
                        id={`${id}-password`}
                        name="password"
                        type="password"
                        autoComplete="new-password"
                        autoCapitalize="none"
                        spellCheck="false"
                        minLength={passwordMinLength}
                        placeholder=" "
                        disabled={isDisabled()}
                        required
                        autoFocus
                    />
                    <label
                        htmlFor={`${id}-password`}
                    >
                        Password
                    </label>
                    <p
                        id={`${id}-password-invalid`}
                        role="alert"
                    >
                        A password with at least {passwordMinLength} characters is required
                    </p>
                </div>
                <div className="row flex-justify-content-space-between flex-align-items-center margin-4-t">
                    <div className="col-auto col-12-sm-down display-inline-flex flex-direction-column">
                        <button
                            className="btn-lg flex-grow-sm-down pad-5-l-sm-up pad-5-r-sm-up"
                            type="submit"
                            disabled={isDisabled()}
                        >
                            {props.submitBtnText || 'Submit'}
                        </button>
                        <p
                            ref={submitMsg}
                            id={`${id}-submit-msg`}
                            className="margin-2-t"
                            role={submissionState.success
                                ? 'status'
                                : 'alert'}
                            style={{
                                display: submissionState.message !== null
                                    && 'block'
                            }}
                            tabIndex="-1"
                        >
                            {submissionState.message}
                        </p>
                    </div>
                    {ticket
                        && (
                            <div className="col-auto col-12-sm-down pad-3-t-sm-down">
                                <Link
                                    className="body-3 text-decoration-underline"
                                    to="/login"
                                >
                                    Return to login
                                </Link>
                            </div>)}
                </div>
            </Form>
        </div>
    )
}
